import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenericConfig } from '@signature-it/ngx-generic/config'
import { SharedDataService } from '@signature-it/ngx-catalogue/services';
import { ProductSolrDTO } from '@signature-it/ngx-catalogue/models';

@Component({
    selector: 'bucket-card',
    templateUrl: './bucket-card.component.html',
    styleUrls: ['./bucket-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BucketCardComponent implements OnInit {

    static readonly BUCKET_PRODUCT_PIC = 'product_pic_s';

    @Input() item: ProductSolrDTO;
    @Input() numFound: number;

    goToDefaultSku: boolean;

    constructor(protected router: Router,
                 public sharedSvc: SharedDataService) {}

    ngOnInit() {
        this.goToDefaultSku = this.numFound === this.item.bucketTotalSkus;
        const defaultSkuFields = [BucketCardComponent.BUCKET_PRODUCT_PIC];
        if (this.goToDefaultSku) {
            defaultSkuFields.forEach(field => {
                this.item[field] = this.item[`bucket_${field}`];
            });
        }
    }

    goToBucket() {
        const skuId = this.goToDefaultSku ? this.item.defaultSku : this.item.product_id_i;
        this.router.navigate(['bucket-page', skuId]);
    }

}
